import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { LandingPageSectionContainerModule } from '@landing-page/components/container/landing-page-section-container.module'
import { TranslationModule } from '@localization-lib/language/translation.module'

@Component({
    standalone: true,
    imports: [
        CommonModule,
        LandingPageSectionContainerModule,
        MatIcon,
        TranslationModule,
    ],
    selector: 'app-landing-page-booking',
    templateUrl: './landing-page-booking.component.html',
})
export class LandingPageBookingComponent {
    useCases = [
        {
            title: 'FastTrack',
            description: 'LandingPageBookingFastTrackText',
            icon: 'fast-track',
        },
        {
            title: 'Wagon Hire',
            description: 'LandingPageBookingWagonHireText',
            icon: 'wagon-hire',
        },
    ]

    constructor() {}
}
